import { jsx as l } from "react/jsx-runtime";
import { c as e } from "../../../index-Cu0xwYjD.js";
import '../../../assets/LabelText.css';const o = "_label_1wfob_4", c = {
  label: o
}, b = ({
  children: a,
  ...s
}) => /* @__PURE__ */ l("span", { ...s, className: e(c.label, s.className), children: a });
export {
  b as LabelText
};
